export class CommuteFltData {
  id?: number;
  fileContent?: string;
  fileName?: string;
}
